import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "user-info-page" }
const _hoisted_2 = { class: "form-section" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "compact-field" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "compact-field" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "compact-field required-field" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "compact-field required-field" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = { class: "compact-field" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "compact-field required-field" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "form-section" }
const _hoisted_19 = { class: "section-title" }
const _hoisted_20 = { class: "compact-field required-field" }
const _hoisted_21 = { class: "phone-input-group" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "compact-field" }
const _hoisted_26 = { class: "phone-input-group" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "compact-field" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "compact-field" }
const _hoisted_33 = { class: "phone-input-group" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "form-section" }
const _hoisted_38 = { class: "section-title" }
const _hoisted_39 = { class: "compact-field" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "compact-field" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "compact-field" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "form-section" }
const _hoisted_46 = { class: "section-title" }
const _hoisted_47 = { class: "address-fields-wrapper" }
const _hoisted_48 = { class: "compact-field required-field" }
const _hoisted_49 = { class: "address-input-group" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "compact-field" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "compact-field" }
const _hoisted_54 = { class: "input-with-suffix" }
const _hoisted_55 = ["type", "disabled"]
const _hoisted_56 = { class: "compact-field" }
const _hoisted_57 = { class: "input-with-suffix" }
const _hoisted_58 = ["type", "disabled"]
const _hoisted_59 = { class: "compact-field" }
const _hoisted_60 = { class: "input-with-suffix" }
const _hoisted_61 = ["type", "disabled"]
const _hoisted_62 = {
  key: 0,
  class: "loading-overlay"
}

import { ref, onMounted, computed, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';

const API_BASE_URL = '/api';

// 이미지 경로 설정

export default /*@__PURE__*/_defineComponent({
  __name: 'PgmUserInfo',
  setup(__props) {

const store = useStore();
const router = useRouter();

// API 기본 URL
const logoImage = ref(new URL('../../../assets/images/hypehive-logo.png', import.meta.url).href);

// 폼 유효성 검사
const formValid = ref(false);
const loading = ref(false);
const form = ref();
const snackbar = ref({ show: false, message: '', color: 'info' });
const addressDialog = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
const addressLoading = ref(false);

// 비밀번호 변경 관련
const passwordDialog = ref(false);
const passwordFormValid = ref(false);
const passwordForm = ref();
const passwordLoading = ref(false);
const showCurrentPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmNewPassword = ref(false);

const passwordData = ref({
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: ''
});

// 공인인증서 업로드(디자인용)
// const certFiles = ref<File[]>([]);
// const certPassword = ref('');
// const showCertPassword = ref(false);

let daumScriptLoading: Promise<void> | null = null;

// 사용자 정보
const userInfo = ref({
  m_idx: 0,
  m_id: '',
  m_sisul_code: '',
  m_longterm_code: '',
  m_pw: '',
  m_sisul_name: '',
  m_biz_gubun: '',
  m_biz_num: '',
  m_user_name: '',
  m_email: '',
  m_sisul_call_num1: '',
  m_sisul_call_num2: '',
  m_sisul_call_num3: '',
  m_phone1: '',
  m_phone2: '',
  m_phone3: '',
  m_fax1: '',
  m_fax2: '',
  m_fax3: '',
  m_bank_num: '',
  m_bank_name: '',
  m_bank_owner: '',
  m_addr: '',
  m_addr_detail: ''
});

// 선택 옵션들
const bizGubunOptions = [
  { title: '재가장기요양센터', value: '재가장기요양센터' },
  { title: '주간보호센터', value: '주간보호센터' },
  { title: '단기보호센터', value: '단기보호센터' },
  { title: '기타', value: '기타' }
];


// 입력값 포맷터
const numbersOnly = (value: string) => value.replace(/[^\d]/g, '');

const formatPhone = (value: string) => {
  const digits = numbersOnly(value).slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
};

const formatBizNum = (value: string) => {
  const digits = numbersOnly(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
};

// 폼 유효성 검사 규칙
const rules = {
  required: (value: string) => !!value || '필수 입력 항목입니다.',
  email: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || '올바른 이메일 형식이 아닙니다.';
  },
  phone: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const phoneRegex = /^01[0-9]-\d{4}-\d{4}$/;
    return phoneRegex.test(value) || '010-1234-5678 형식으로 입력해주세요.';
  },
  bizNum: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const bizNumRegex = /^\d{3}-\d{2}-\d{5}$/;
    return bizNumRegex.test(value) || '123-45-67890 형식으로 입력해주세요.';
  },
  password: (value: string) => value.length >= 6 || '6자 이상 입력해주세요.',
  confirmNewPassword: (value: string) => {
    if (!value) return '비밀번호 확인을 입력해주세요.';
    return value === passwordData.value.newPassword || '비밀번호가 일치하지 않습니다.';
  }
};

// 주소 검색 관련 함수들
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openDaumPostcodePopup = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode not loaded');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressLoading.value = false;
      }
    });
    postcode.open();
    addressLoading.value = false;
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

// 주소 찾기 모달 열기
const openAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      // 임베드 실패 시 팝업 방식으로 대체
      addressDialog.value = false;
      try {
        await openDaumPostcodePopup();
      } catch (err) {
        snackbar.value.message = '주소 검색 로드에 실패했습니다. 네트워크를 확인해주세요.';
        snackbar.value.color = 'error';
        snackbar.value.show = true;
      }
    }
  }
});

// 컴포넌트 마운트 시 로그인 상태 확인 및 사용자 정보 로드
onMounted(async () => {
  await store.dispatch('validateAuth');
  if (!store.getters.isLoggedIn) {
    router.push('/pgm/login');
    return;
  }
  
  // 현재 사용자 정보로 초기화
  const currentUser = store.getters.currentUser;
  if (currentUser) {
    userInfo.value = { ...currentUser };
  }
});

// 비밀번호 변경 모달 열기
const openPasswordModal = () => {
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordDialog.value = true;
};

// 비밀번호 변경 모달 닫기
const closePasswordModal = () => {
  passwordDialog.value = false;
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  showCurrentPassword.value = false;
  showNewPassword.value = false;
  showConfirmNewPassword.value = false;
};

// 새 비밀번호 확인 유효성 검사 강제 실행
const validateConfirmNewPassword = () => {
  if (passwordForm.value) {
    nextTick(() => {
      passwordForm.value.validate();
    });
  }
};

// 비밀번호 변경
const changePassword = async () => {
  if (!passwordFormValid.value) return;
  
  passwordLoading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/password`, {
      currentPassword: passwordData.value.currentPassword,
      newPassword: passwordData.value.newPassword
    }, {
      withCredentials: true,
      timeout: 10000
    });
    
    const result = response.data;
    
    if (result.success) {
      snackbar.value.message = '비밀번호가 성공적으로 변경되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
      closePasswordModal();
    } else {
      console.error('비밀번호 변경 실패:', result.message);
      snackbar.value.message = result.message || '비밀번호 변경에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('비밀번호 변경 오류:', error);
    snackbar.value.message = '비밀번호 변경 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    passwordLoading.value = false;
  }
};

// 사용자 정보 수정
const updateUserInfo = async () => {
  loading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/account`, userInfo.value, {
      withCredentials: true,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const result = response.data;
    if (result.success) {
      // Vuex 스토어의 사용자 정보도 업데이트 (저장소에도 저장)
      store.commit('updateUser', userInfo.value);
      snackbar.value.message = '사용자 정보가 성공적으로 수정되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
    } else {
      console.error('사용자 정보 수정 실패:', result.message);
      snackbar.value.message = result.message || '사용자 정보 수정에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('사용자 정보 수정 오류:', error);
    snackbar.value.message = '사용자 정보 수정 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "user-info-card",
      elevation: "8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "text-center signup-title" }, {
          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
            _createElementVNode("div", { class: "signup-title-text" }, "사용자 정보 수정", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              ref_key: "form",
              ref: form,
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formValid).value = $event)),
              onSubmit: _withModifiers(updateUserInfo, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#133e87",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-account-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createTextVNode(" 기본 정보 ", -1))
                  ]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "compact-label" }, "아이디", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInfo.value.m_id) = $event)),
                              type: "text",
                              class: "compact-input",
                              readonly: "",
                              disabled: loading.value,
                              autocomplete: "username"
                            }, null, 8, _hoisted_5), [
                              [_vModelText, userInfo.value.m_id]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "compact-label" }, "장기요양기관기호", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInfo.value.m_longterm_code) = $event)),
                              type: "text",
                              class: "compact-input",
                              readonly: "",
                              disabled: loading.value,
                              autocomplete: "off"
                            }, null, 8, _hoisted_7), [
                              [_vModelText, userInfo.value.m_longterm_code]
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "compact-label" }, [
                              _createTextVNode("대표자명 "),
                              _createElementVNode("span", { class: "required-mark" }, "*")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userInfo.value.m_user_name) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "대표자명을 입력하세요",
                              disabled: loading.value,
                              autocomplete: "name",
                              maxlength: "20"
                            }, null, 8, _hoisted_9), [
                              [_vModelText, userInfo.value.m_user_name]
                            ]),
                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "field-hint" }, "임금신고 시 필수 입력 항목입니다.", -1))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _cache[50] || (_cache[50] = _createElementVNode("label", { class: "compact-label" }, [
                              _createTextVNode("기관명 "),
                              _createElementVNode("span", { class: "required-mark" }, "*")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userInfo.value.m_sisul_name) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "기관명을 입력하세요",
                              disabled: loading.value,
                              autocomplete: "organization",
                              maxlength: "50"
                            }, null, 8, _hoisted_11), [
                              [_vModelText, userInfo.value.m_sisul_name]
                            ]),
                            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "field-hint" }, "임금신고 시 필수 입력 항목입니다.", -1))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", _hoisted_13, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#133e87",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                        _createTextVNode("mdi-domain", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[53] || (_cache[53] = _createTextVNode(" 업체 정보 ", -1))
                  ]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[54] || (_cache[54] = _createElementVNode("label", { class: "compact-label" }, "사업형태", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userInfo.value.m_biz_gubun) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "예: 재가장기요양센터",
                              disabled: loading.value,
                              autocomplete: "off",
                              maxlength: "30"
                            }, null, 8, _hoisted_15), [
                              [_vModelText, userInfo.value.m_biz_gubun]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[55] || (_cache[55] = _createElementVNode("label", { class: "compact-label" }, [
                              _createTextVNode("사업자등록번호 "),
                              _createElementVNode("span", { class: "required-mark" }, "*")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userInfo.value.m_biz_num) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "123-45-67890",
                              disabled: loading.value,
                              autocomplete: "off",
                              onInput: _cache[6] || (_cache[6] = (e) => (userInfo.value.m_biz_num = formatBizNum(e.target.value))),
                              maxlength: "12"
                            }, null, 40, _hoisted_17), [
                              [_vModelText, userInfo.value.m_biz_num]
                            ]),
                            _cache[56] || (_cache[56] = _createElementVNode("span", { class: "field-hint" }, "임금신고 시 필수 입력 항목입니다.", -1))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("h3", _hoisted_19, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#133e87",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                        _createTextVNode("mdi-phone", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[58] || (_cache[58] = _createTextVNode(" 연락처 정보 ", -1))
                  ]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[61] || (_cache[61] = _createElementVNode("label", { class: "compact-label" }, [
                              _createTextVNode("기관 전화번호 "),
                              _createElementVNode("span", { class: "required-mark" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((userInfo.value.m_sisul_call_num1) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "02",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[8] || (_cache[8] = (e) => (userInfo.value.m_sisul_call_num1 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_22), [
                                [_vModelText, userInfo.value.m_sisul_call_num1]
                              ]),
                              _cache[59] || (_cache[59] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userInfo.value.m_sisul_call_num2) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "1234",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[10] || (_cache[10] = (e) => (userInfo.value.m_sisul_call_num2 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_23), [
                                [_vModelText, userInfo.value.m_sisul_call_num2]
                              ]),
                              _cache[60] || (_cache[60] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userInfo.value.m_sisul_call_num3) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "5678",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[12] || (_cache[12] = (e) => (userInfo.value.m_sisul_call_num3 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_24), [
                                [_vModelText, userInfo.value.m_sisul_call_num3]
                              ])
                            ]),
                            _cache[62] || (_cache[62] = _createElementVNode("span", { class: "field-hint" }, "임금신고 시 필수 입력 항목입니다.", -1))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[65] || (_cache[65] = _createElementVNode("label", { class: "compact-label" }, "대표자 휴대폰", -1)),
                            _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((userInfo.value.m_phone1) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "010",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[14] || (_cache[14] = (e) => (userInfo.value.m_phone1 = numbersOnly(e.target.value).slice(0, 3))),
                                maxlength: "3"
                              }, null, 40, _hoisted_27), [
                                [_vModelText, userInfo.value.m_phone1]
                              ]),
                              _cache[63] || (_cache[63] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((userInfo.value.m_phone2) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "1234",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[16] || (_cache[16] = (e) => (userInfo.value.m_phone2 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_28), [
                                [_vModelText, userInfo.value.m_phone2]
                              ]),
                              _cache[64] || (_cache[64] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((userInfo.value.m_phone3) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "5678",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[18] || (_cache[18] = (e) => (userInfo.value.m_phone3 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_29), [
                                [_vModelText, userInfo.value.m_phone3]
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[66] || (_cache[66] = _createElementVNode("label", { class: "compact-label" }, "이메일", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((userInfo.value.m_email) = $event)),
                              type: "email",
                              class: "compact-input",
                              placeholder: "이메일을 입력하세요",
                              disabled: loading.value,
                              autocomplete: "email",
                              maxlength: "100"
                            }, null, 8, _hoisted_31), [
                              [_vModelText, userInfo.value.m_email]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_32, [
                            _cache[69] || (_cache[69] = _createElementVNode("label", { class: "compact-label" }, "팩스번호", -1)),
                            _createElementVNode("div", _hoisted_33, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((userInfo.value.m_fax1) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "02",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[21] || (_cache[21] = (e) => (userInfo.value.m_fax1 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_34), [
                                [_vModelText, userInfo.value.m_fax1]
                              ]),
                              _cache[67] || (_cache[67] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((userInfo.value.m_fax2) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "1234",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[23] || (_cache[23] = (e) => (userInfo.value.m_fax2 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_35), [
                                [_vModelText, userInfo.value.m_fax2]
                              ]),
                              _cache[68] || (_cache[68] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((userInfo.value.m_fax3) = $event)),
                                type: "text",
                                class: "compact-input phone-input",
                                placeholder: "5678",
                                disabled: loading.value,
                                autocomplete: "tel",
                                onInput: _cache[25] || (_cache[25] = (e) => (userInfo.value.m_fax3 = numbersOnly(e.target.value).slice(0, 4))),
                                maxlength: "4"
                              }, null, 40, _hoisted_36), [
                                [_vModelText, userInfo.value.m_fax3]
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h3", _hoisted_38, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#133e87",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                        _createTextVNode("mdi-bank", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[71] || (_cache[71] = _createTextVNode(" 은행 정보 ", -1))
                  ]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[72] || (_cache[72] = _createElementVNode("label", { class: "compact-label" }, "은행명", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((userInfo.value.m_bank_name) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "은행명을 입력하세요",
                              disabled: loading.value,
                              autocomplete: "off",
                              maxlength: "20"
                            }, null, 8, _hoisted_40), [
                              [_vModelText, userInfo.value.m_bank_name]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[73] || (_cache[73] = _createElementVNode("label", { class: "compact-label" }, "계좌번호", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((userInfo.value.m_bank_num) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "계좌번호를 입력하세요",
                              disabled: loading.value,
                              autocomplete: "off",
                              maxlength: "50"
                            }, null, 8, _hoisted_42), [
                              [_vModelText, userInfo.value.m_bank_num]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4",
                        class: "pb-0 pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_43, [
                            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "compact-label" }, "예금주", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((userInfo.value.m_bank_owner) = $event)),
                              type: "text",
                              class: "compact-input",
                              placeholder: "예금주를 입력하세요",
                              disabled: loading.value,
                              autocomplete: "off",
                              maxlength: "45"
                            }, null, 8, _hoisted_44), [
                              [_vModelText, userInfo.value.m_bank_owner]
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("h3", _hoisted_46, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#133e87",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                        _createTextVNode("mdi-map-marker", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[76] || (_cache[76] = _createTextVNode(" 주소 정보 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[79] || (_cache[79] = _createElementVNode("label", { class: "compact-label" }, [
                        _createTextVNode("주소 "),
                        _createElementVNode("span", { class: "required-mark" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((userInfo.value.m_addr) = $event)),
                          type: "text",
                          class: "compact-input",
                          placeholder: "주소 검색 버튼을 클릭하세요",
                          disabled: loading.value,
                          readonly: "",
                          autocomplete: "street-address",
                          maxlength: "150",
                          onClick: openAddressModal
                        }, null, 8, _hoisted_50), [
                          [_vModelText, userInfo.value.m_addr]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "address-search-btn",
                          onClick: openAddressModal
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                              _createTextVNode("mdi-magnify", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[78] || (_cache[78] = _createTextVNode(" 주소검색 ", -1))
                        ])
                      ]),
                      _cache[80] || (_cache[80] = _createElementVNode("span", { class: "field-hint" }, "임금신고 시 필수 입력 항목입니다.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _cache[81] || (_cache[81] = _createElementVNode("label", { class: "compact-label" }, "상세주소", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((userInfo.value.m_addr_detail) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "상세주소를 입력해주세요 (동/호수 등)",
                        disabled: loading.value,
                        autocomplete: "address-line2",
                        maxlength: "100"
                      }, null, 8, _hoisted_52), [
                        [_vModelText, userInfo.value.m_addr_detail]
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, { class: "pl-4 pr-4 pt-2 pb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: updateUserInfo,
                      color: "primary",
                      variant: "flat",
                      block: "",
                      size: "default",
                      loading: loading.value,
                      rounded: "lg",
                      class: "signup-submit-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                            _createTextVNode("mdi-content-save", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[83] || (_cache[83] = _createTextVNode(" 정보 수정 ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: openPasswordModal,
                      color: "secondary",
                      variant: "outlined",
                      block: "",
                      size: "default",
                      disabled: loading.value,
                      rounded: "lg",
                      class: "login-back-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                            _createTextVNode("mdi-lock-reset", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[85] || (_cache[85] = _createTextVNode(" 비밀번호 변경 ", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      class: "password-dialog",
      modelValue: passwordDialog.value,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((passwordDialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "font-weight-bold d-flex align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "primary",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                    _createTextVNode("mdi-lock-reset", -1)
                  ]))]),
                  _: 1
                }),
                _cache[87] || (_cache[87] = _createTextVNode(" 비밀번호 변경 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "passwordForm",
                  ref: passwordForm,
                  modelValue: passwordFormValid.value,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((passwordFormValid).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[88] || (_cache[88] = _createElementVNode("label", { class: "compact-label" }, "현재 비밀번호 *", -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((passwordData.value.currentPassword) = $event)),
                          type: showCurrentPassword.value ? 'text' : 'password',
                          class: "compact-input",
                          placeholder: "현재 비밀번호를 입력하세요",
                          disabled: passwordLoading.value,
                          autocomplete: "current-password",
                          maxlength: "50"
                        }, null, 8, _hoisted_55), [
                          [_vModelDynamic, passwordData.value.currentPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "password-toggle-btn",
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (showCurrentPassword.value = !showCurrentPassword.value))
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(showCurrentPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _cache[89] || (_cache[89] = _createElementVNode("label", { class: "compact-label" }, "새 비밀번호 *", -1)),
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((passwordData.value.newPassword) = $event)),
                          type: showNewPassword.value ? 'text' : 'password',
                          class: "compact-input",
                          placeholder: "새 비밀번호를 입력하세요",
                          disabled: passwordLoading.value,
                          onInput: validateConfirmNewPassword,
                          autocomplete: "new-password",
                          maxlength: "50"
                        }, null, 40, _hoisted_58), [
                          [_vModelDynamic, passwordData.value.newPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "password-toggle-btn",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(showNewPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[90] || (_cache[90] = _createElementVNode("label", { class: "compact-label" }, "새 비밀번호 확인 *", -1)),
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((passwordData.value.confirmNewPassword) = $event)),
                          type: showConfirmNewPassword.value ? 'text' : 'password',
                          class: "compact-input",
                          placeholder: "새 비밀번호를 다시 입력하세요",
                          disabled: passwordLoading.value,
                          autocomplete: "new-password",
                          maxlength: "50"
                        }, null, 8, _hoisted_61), [
                          [_vModelDynamic, passwordData.value.confirmNewPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "password-toggle-btn",
                          onClick: _cache[37] || (_cache[37] = ($event: any) => (showConfirmNewPassword.value = !showConfirmNewPassword.value))
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(showConfirmNewPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4 pt-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: closePasswordModal,
                  disabled: passwordLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  onClick: changePassword,
                  loading: passwordLoading.value,
                  disabled: !passwordFormValid.value,
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                      default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[93] || (_cache[93] = _createTextVNode(" 변경하기 ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: addressDialog.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((addressDialog).value = $event)),
      "max-width": "560"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                _createTextVNode("주소 검색", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"height":"420px","position":"relative"} }, {
              default: _withCtx(() => [
                (addressLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary",
                        size: "48"
                      }),
                      _cache[95] || (_cache[95] = _createElementVNode("div", { class: "loading-text mt-3" }, "주소 검색을 불러오는 중...", -1))
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  ref_key: "postcodeContainer",
                  ref: postcodeContainer,
                  style: {"width":"100%","height":"100%"}
                }, null, 512), [
                  [_vShow, !addressLoading.value]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[40] || (_cache[40] = ($event: any) => (addressDialog.value = false)),
                  disabled: addressLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: "2500",
      rounded: "lg",
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})